<template>
<div class="add-via-webDav">
    <div >
        <span class="add-ftp-des" v-html="$t('language.popup.addCloudPopup.addNasWebDes')"></span>
    </div>
    <div class="viaWEB-body">
        <div class="cloud-cont">
            <div class="cloud-viaWeb-name">{{$t('language.popup.addCloudPopup.displayName')}}</div>
            <input :style="{width:this.$i18n.locale =='italian'?'450Px':''}" type="text" v-model="inputCloudNameValue" class="cloud-cont-input">
        </div>
        <div class="cloud-cont">
            <font class="cloud-viaWeb-name">{{$t('language.popup.addCloudPopup.server')}}</font>
            <input  type="text" class="ftp-cont-right-one" v-model="portNumber">
            <input :style="{width:this.$i18n.locale =='italian'?'260Px':'290Px'}" type="text" class="ftp-cont-input" v-model="webDavserverHttp" >
        </div>
        <!-- 显示问号 -->
        <div class="question-mark" style="float: left;position: absolute;" @mouseleave="explanShow=false" @mouseover="explanShow=true">
            <div class="icon-util question viaWeb-icon-position">
                <div class="webdav-explanation explanation nas-web-positon" >
                    <font v-html="$t('language.popup.addCloudPopup.webDavQuestion')"></font>
                </div>
            </div>
        </div>
        <div class="cloud-cont">
            <font class="cloud-viaWeb-name">{{$t('language.popup.addCloudPopup.userName')}}</font>
            <input :style="{width:this.$i18n.locale =='italian'?'450Px':''}" type="text" v-model="username" class="cloud-cont-input">
        </div>
        <div class="cloud-cont">
            <font class="cloud-viaWeb-name">{{$t('language.popup.addCloudPopup.passWord')}}</font>
            <input :style="{width:this.$i18n.locale =='italian'?'450Px':''}" v-model="password" type="password" class="cloud-cont-input">
        </div>
        <div class="cloud-cont">
            <font class="cloud-viaWeb-name">{{$t('language.popup.addCloudPopup.path')}}</font>
            <input :style="{width:this.$i18n.locale =='italian'?'450Px':''}" type="text" v-model="path" class="cloud-cont-input">
        </div>
    </div>
</div>
</template>

<script>
export default {
    data: function () {
        return {
            inputCloudNameValue: 'NAS',
            webDavserverHttp: 'https://',
            username: '',
            password: '',
            path: '',
            explanShow: false,
            portNumber:443,
        }
    }
}
</script>

<style>
.add-via-webDav {
    width: 100%;
    padding-top: 15px;
    /*no*/
    min-height: 265px;
    /*no*/
}

.viaWeb-icon-position {
    position: relative;
    top: -26Px;
    float: right;
    left: 610Px;
}

.cloud-viaWeb-name {
    font-size: 14px;
    /*no*/
    float: left;
    line-height: 50px;
    /*no*/
    position: relative;
    height: 35px;
    /*no*/
    min-width: 120Px;
    /*no*/
    text-align: left;
    box-sizing: border-box;
}

.viaWEB-body {
    width: 610Px;
    margin-left: 5Px;
}

.webdav-explanation {
    top: -68px;
    /*no*/
    left: -17px;
    /*no*/
}
.nas-web-positon{
    display: none;
}
.question:hover .nas-web-positon{
    display: block;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_add_cloud/tab_via_webDav.vue